module.exports = __webpack_public_path__ + "img/main_button_moresearch_up.32c46d98.png";